import * as React from 'react';
import CloudDownloadIcon from '@mui/icons-material/CloudDownload';
import Tooltip, { TooltipProps } from '@mui/material/Tooltip';
import useGlynt from '../hooks/useGlynt';
import { AppContext } from '../../App';
import { IDataExport } from '../../types/my-types';
import { saveAs } from 'file-saver';
import { useQueryClient } from '@tanstack/react-query';
import { useTheme } from '@mui/material/styles';

interface Props {
  exportRow: IDataExport;
}

function DownloadExport({ exportRow }: Props) {
  const { setToast } = React.useContext(AppContext);
  const client = useQueryClient();
  const glynt = useGlynt();
  const theme = useTheme();

  const download = () => {
    setToast({
      open: true,
      message: 'Downloading export...',
      variant: 'success',
    });
    client.fetchQuery({
        queryKey: ['data-export-download'],
        queryFn: async () => (await glynt).dataExports.download(exportRow.file_access_url),
      })
      .then((data) => {
        const fileURL = data.file_temp_url;

        fetch(fileURL, {
          method: 'get',
          headers: new Headers({
            accept: 'Content-Disposition',
          }),
        }).then((data) => {
          if (data.status === 200) {
            data.blob().then((text) => {
              saveAs(text, `${exportRow.id}.csv`);
            });
          } else {
            setToast({
              open: true,
              message: 'Failed to download document',
              variant: 'error',
            });
          }
        });
      });
  };

  return (
    <Tooltip
      placement="top"
      title="Download Export"
      disableFocusListener
      disableTouchListener
      PopperProps={
        {
          popperOptions: {
            modifiers: [
              {
                name: 'offset',
                options: {
                  offset: [0, 0],
                },
              },
            ],
          },
        } as TooltipProps['PopperProps']
      }
    >
      <CloudDownloadIcon
        data-cy="btn-data-exports-download-file"
        onClick={() => download()}
        style={{ color: theme.palette.custom.lightGreen, cursor: 'pointer' }}
      />
    </Tooltip>
  );
}

export default DownloadExport;
